export const INLINE_SAVE_CONFLICT_MESSAGE = 'Updated elsewhere. Refresh and retry.';
export const BANNER_SAVE_CONFLICT_MESSAGE = 'Someone updated this information while you were editing. Refresh to see the latest version.';

// Backward-compatible alias for inline field/document conflict messaging.
export const SAVE_CONFLICT_MESSAGE = INLINE_SAVE_CONFLICT_MESSAGE;

export function extractConflictPaths(conflicts: unknown): string[] {
    if (!Array.isArray(conflicts)) {
        return [];
    }

    const uniquePaths = new Set<string>();
    for (const conflict of conflicts) {
        const path = typeof (conflict as any)?.path === 'string'
            ? (conflict as any).path.trim()
            : '';
        if (path) {
            uniquePaths.add(path);
        }
    }

    return Array.from(uniquePaths);
}

export function hasConflictForAnyPath(
    conflictPaths: string[] | undefined,
    candidatePaths: string[]
): boolean {
    if (!Array.isArray(conflictPaths) || conflictPaths.length === 0 || candidatePaths.length === 0) {
        return false;
    }

    return candidatePaths.some((candidatePathRaw) => {
        const candidatePath = (candidatePathRaw || '').trim();
        if (!candidatePath) {
            return false;
        }

        return conflictPaths.some((conflictPathRaw) => {
            const conflictPath = (conflictPathRaw || '').trim();
            if (!conflictPath) {
                return false;
            }

            return (
                conflictPath === candidatePath
                || conflictPath.startsWith(`${candidatePath}.`)
                || candidatePath.startsWith(`${conflictPath}.`)
            );
        });
    });
}
